import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportOranSchemaConfigs, exportSchemaConfigs } from '@api/schemaConfig';

import { IGroupOperationWithActionDTO } from '@interfaces/common/defaultDTO';
import { IOnSuccess } from '@interfaces/common/handlers';

import { EMenuActionsTypes, ESnackbarTypes } from '@enums/common';

import { SCHEMA_CONFIG_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export interface IUserSchemaExport extends Partial<IOnSuccess> {
	isOranVendor: boolean;
}

interface IMavenirSchemaReturnType {
	exportSchema: (dto: IGroupOperationWithActionDTO) => void;
	isLoadingExportSchema: boolean;
}

export function useMutateSchemaExport(props?: IUserSchemaExport): IMavenirSchemaReturnType {
	const dispatch = useAppDispatch();
	const { onSuccess, isOranVendor } = props || {};
	const queryFn = isOranVendor ? exportOranSchemaConfigs : exportSchemaConfigs;

	const {
		mutate: exportSchema,
		isLoading: isLoadingExportSchema,
	} = useMutation<IGroupOperationWithActionDTO>({
		mutationKey: [SCHEMA_CONFIG_EXPORT],
		mutationFn: ({ ids, actionType }: IGroupOperationWithActionDTO) => {
			const exportData = {
				ids,
				isAll: actionType === EMenuActionsTypes.all || actionType === EMenuActionsTypes.allFiltered,
			};

			return queryFn(exportData);
		},
		onSuccess: () => {
			if (onSuccess) onSuccess();

			dispatch(setSnackbar({
				message: responseMessages.exportStartingNotificationSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		exportSchema,
		isLoadingExportSchema,
	};
}
